import { render, staticRenderFns } from "./FormMultipleValueVertical.vue?vue&type=template&id=70d33200&"
import script from "./FormMultipleValueVertical.vue?vue&type=script&lang=js&"
export * from "./FormMultipleValueVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports